import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilePdf } from '@fortawesome/pro-light-svg-icons';

function PODocumentsForm({
  purchaseOrderNumber,
  onPurchaseOrderNumberChange,
  onDownloadInvoice,
  onDownloadQuote,
}) {
  return (
    <div>
      <div className="row mb-3">
        <div className="col-sm-3 text-sm-right">
          <b>Purchase Order #</b>
          <br />
          <small>(Optional)</small>
        </div>
        <div className="col-sm-9 col-xl-4 col-lg-6">
          <input
            type="text"
            className="form-control"
            value={purchaseOrderNumber}
            onChange={(e) => onPurchaseOrderNumberChange(e.target.value)}
          />
        </div>
      </div>

      <div className="row mb-3">
        {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
        <label className="col-form-label col-sm-3 text-sm-right"><b>Documents</b></label>
        <div className="col-sm-9 d-flex align-items-center">
          <FontAwesomeIcon icon={faFilePdf} className="mr-1" />
          <button
            type="button"
            className="btn btn-link p-0 mr-4"
            style={{ textDecoration: 'underline' }}
            onClick={onDownloadInvoice}
          >
            Download an Invoice
          </button>
          <FontAwesomeIcon icon={faFilePdf} className="mr-1" />
          <button
            type="button"
            className="btn btn-link p-0"
            style={{ textDecoration: 'underline' }}
            onClick={onDownloadQuote}
          >
            Download a Quote
          </button>
        </div>
      </div>
    </div>
  );
}

PODocumentsForm.propTypes = {
  purchaseOrderNumber: PropTypes.string.isRequired,
  onPurchaseOrderNumberChange: PropTypes.func.isRequired,
  onDownloadInvoice: PropTypes.func.isRequired,
  onDownloadQuote: PropTypes.func.isRequired,
};

export default PODocumentsForm;
